<div class="warehouse-list">
  <div class="warehouse-toolbar">
    <div>
      <h2><mat-icon>inventory_2</mat-icon> Склады поставщика</h2>
      <span>{{ warehouses.length }} записей</span>
    </div>

    <button mat-flat-button color="primary" type="button" (click)="addWh()" [disabled]="dialogOpen">
      <mat-icon>add</mat-icon>
      Склад
    </button>
  </div>

  <div class="warehouse-filters">
    <mat-form-field appearance="outline">
      <mat-label>Склад-получатель</mat-label>
      <mat-select [value]="receiverWarehouseId" (selectionChange)="selectReceiver($event.value)">
        <mat-option *ngFor="let receiver of receiverWarehouses" [value]="receiver.id">
          {{ receiver.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Поиск по складу</mat-label>
      <input matInput type="text" [formControl]="control" />
      <button
        matSuffix
        mat-icon-button
        type="button"
        aria-label="Очистить"
        title="Очистить"
        *ngIf="control.value"
        (click)="control.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <span *ngIf="receiverLoadError">{{ receiverLoadError }}</span>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="warehouse-error" *ngIf="error" role="alert">{{ error }}<button mat-stroked-button type="button" (click)="search()" [disabled]="loading">Повторить</button></div>
  <div class="warehouse-table-shell">
    <table mat-table [dataSource]="warehouses">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let wh" class="whId">{{ wh.id }}</td>
      </ng-container>

      <ng-container matColumnDef="wh">
        <th mat-header-cell *matHeaderCellDef>Склад</th>
        <td mat-cell *matCellDef="let wh" class="whDescription">{{ wh.description || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef>Город</th>
        <td mat-cell *matCellDef="let wh" class="whCity">{{ wh.city?.description || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="delivery">
        <th mat-header-cell *matHeaderCellDef>Доставка</th>
        <td mat-cell *matCellDef="let wh" class="whDelivery">
          <a
            class="delivery-link"
            [routerLink]="['/provider/warehouse', wh.id, 'delivery']"
            [queryParams]="receiverQueryParams"
          >
            {{ deliverySummary(wh) || 'Настроить' }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let wh" class="warehouse-actions">
          <a
            mat-icon-button
            color="primary"
            aria-label="Доставка"
            title="Доставка"
            [routerLink]="['/provider/warehouse', wh.id, 'delivery']"
            [queryParams]="receiverQueryParams"
          >
            <mat-icon>local_shipping</mat-icon>
          </a>
          <button
            mat-icon-button
            color="primary"
            type="button"
            aria-label="Редактировать"
            title="Редактировать"
            (click)="updateWh(wh)" [disabled]="dialogOpen"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            type="button"
            aria-label="Удалить"
            title="Удалить"
            (click)="removeWh(wh)" [disabled]="deletingId !== null"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>

    <div class="empty-state" *ngIf="!warehouses.length && !loading && !error">
      <mat-icon>inventory_2</mat-icon>
      <span>Склады не найдены</span>
    </div>
  </div>
</div>
